import {
  Box,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { SearchablePopoverTriggerProps } from "./searchable-popover.types";

export const SearchablePopoverTrigger = <T,>({
  value,
  renderValue,
  placeholder = "Select",
  label,
  disabled = false,
  fullWidth = false,
  error = false,
  helperText,
  size = "small",
  variant = "outlined",
  sx,
  onClick,
}: SearchablePopoverTriggerProps<T>) => {
  const adornmentContent = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flex: 1,
        minWidth: 0,
      }}
    >
      {value ? (
        renderValue(value)
      ) : (
        <Typography
          color="text.secondary"
          noWrap
        >
          {placeholder}
        </Typography>
      )}
    </Box>
  );

  const endAdornment = (
    <KeyboardArrowDownIcon
      sx={{
        color: "text.secondary",
        pointerEvents: "none",
      }}
    />
  );

  const inputSx = {
    cursor: disabled ? "default" : "pointer",
    "& input": {
      width: 0,
      padding: 0,
      cursor: "pointer",
    },
    ...sx,
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      error={error}
      disabled={disabled}
      size={size}
      variant={variant}
    >
      {label && (
        <InputLabel
          shrink={variant === "outlined" ? true : undefined}
          sx={{
            fontSize: "1.05rem",
            fontWeight: 700,
            color: "#757575",
            backgroundColor: "var(--parent-bg)",
            borderRadius: "3px",
            "&.Mui-focused": { color: "#5a5a5a" },
            "&.Mui-error": { color: "#dc2626" },
            "&.Mui-disabled": { color: "#757575" },
            "&.MuiInputLabel-shrink": {
              fontSize: "1.055rem",
              fontWeight: 700,
              marginTop: "-0.15rem",
              color: "#5a5a5a",
              backgroundColor: "var(--parent-bg)",
              borderRadius: "3px",
              paddingRight: "6px"
            },
          }}
        >
          {label}
        </InputLabel>
      )}

      {variant === "standard" ? (
        <Input
          readOnly
          value=""
          onClick={onClick}
          endAdornment={endAdornment}
          startAdornment={adornmentContent}
          sx={inputSx}
        />
      ) : (
        <OutlinedInput
          readOnly
          value=""
          label={label || undefined}
          notched={!!label}
          onClick={onClick}
          endAdornment={endAdornment}
          startAdornment={adornmentContent}
          sx={inputSx}
        />
      )}

      {helperText && (
        <FormHelperText>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};